import {
  getTemaRouteById,
  normalizeTemaHash,
  resolveTemaRoute,
} from "../../routes/resolveTemaRoute";
import { resolveToolRouteHash } from "./resolveToolRouteHash";

export function isViewingToolRoute(toolId) {
  if (!toolId || typeof window === "undefined") {
    return false;
  }

  const targetRoute = getTemaRouteById(toolId);
  if (!targetRoute || targetRoute.id === "not-found") {
    const toolRoute = resolveToolRouteHash(toolId);
    if (!toolRoute) {
      return false;
    }
    return normalizeTemaHash(window.location.hash) === normalizeTemaHash(toolRoute);
  }

  const currentRoute = resolveTemaRoute(window.location.hash);
  return currentRoute.id === targetRoute.id;
}

export function isViewingToolPage(toolId, currentRouteId) {
  if (!toolId) {
    return false;
  }

  if (currentRouteId && currentRouteId === toolId) {
    return true;
  }

  return isViewingToolRoute(toolId);
}

export function shouldShowGenerationCompletionToast(
  toolId,
  { foregroundToolIds = [], currentRouteId = null } = {},
) {
  if (isViewingToolPage(toolId, currentRouteId)) {
    return false;
  }

  if (foregroundToolIds.includes(toolId)) {
    return false;
  }

  return true;
}
